import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';

const PURPLE = '#200854';
const ORANGE = '#FF6600';

interface Props {
  onAccept: () => void;
}

const GdprConsentModal: React.FC<Props> = ({ onAccept }) => {
  const [agreed, setAgreed] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleAccept = async () => {
    setLoading(true);
    try {
      await authAPI.acceptGdprConsent();
      onAccept();
    } catch {
      // silently retry on next interaction
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm px-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 space-y-5 animate-fadeIn">
        <div className="flex items-center gap-3">
          <div
            className="w-10 h-10 rounded-full flex items-center justify-center text-white text-lg font-bold"
            style={{ backgroundColor: PURPLE }}
          >
            🔒
          </div>
          <h2 className="text-lg font-bold" style={{ color: PURPLE }}>
            Ochrana osobných údajov
          </h2>
        </div>

        <p className="text-sm text-gray-600 leading-relaxed">
          Pre používanie aplikácie NajSport potrebujeme váš súhlas so spracovaním osobných údajov
          v súlade s nariadením GDPR. Vaše údaje používame výlučne na poskytovanie služieb aplikácie.
        </p>

        <div className="bg-gray-50 rounded-xl p-4 text-xs text-gray-500 space-y-1">
          <p>• Zbierame len nevyhnutné údaje (meno, email, profil jazdca)</p>
          <p>• Údaje nikomu nepredávame</p>
          <p>• Kedykoľvek si môžete stiahnuť alebo vymazať svoje údaje</p>
          <p>• Technické logy mažeme automaticky po 90 dňoch</p>
        </div>

        <button
          type="button"
          onClick={() => navigate('/privacy-policy')}
          className="text-sm font-medium underline transition-colors"
          style={{ color: PURPLE }}
        >
          Prečítať úplné zásady ochrany osobných údajov →
        </button>

        <label className="flex items-start gap-3 cursor-pointer select-none">
          <input
            type="checkbox"
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
            className="mt-0.5 h-5 w-5 rounded border-gray-300 accent-orange-500"
          />
          <span className="text-sm text-gray-700">
            Súhlasím so spracovaním mojich osobných údajov podľa{' '}
            <span className="font-medium" style={{ color: PURPLE }}>
              zásad ochrany osobných údajov
            </span>
          </span>
        </label>

        <button
          onClick={handleAccept}
          disabled={!agreed || loading}
          className="w-full py-3 rounded-xl text-white font-bold text-sm transition-all disabled:opacity-40 disabled:cursor-not-allowed"
          style={{ backgroundColor: agreed ? ORANGE : '#ccc' }}
        >
          {loading ? 'Spracovávam...' : 'Súhlasím a pokračovať'}
        </button>
      </div>
    </div>
  );
};

export default GdprConsentModal;
